import React from 'react';

export default function AllRewardTransactions({ transactions }) {
  return (
    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
      <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
        <div className="overflow-hidden border-b border-gray-200">
          {transactions.length > 0 ? (
            <table className={'min-w-full divide-y divide-gray-200'}>
              <tr className={'align-top'}>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Transaction ID
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Country Code
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Operator Name
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Amount Requested
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Amount Delivered
                </th>
                <th
                  scope="col"
                  className={
                    'px-2 text-left text-gray-700 font-medium tracking-wider'
                  }
                >
                  Transaction Date
                </th>
              </tr>
              <tbody>
                {transactions.map((item, index) => (
                  <tr
                    className={'border-b border-gray-200 align-top'}
                    key={index}
                  >
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.transactionId}
                    </td>
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.countryCode}
                    </td>
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.operatorName}
                    </td>
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.requestedAmountCurrencyCode} {item.requestedAmount}
                    </td>
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.requestedAmountCurrencyCode} {item.deliveredAmount}
                    </td>
                    <td
                      className={
                        'text-left text-sm lg:text-base font-normal px-2 py-2'
                      }
                    >
                      {item.transactionDate}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div className={'p-10 flex justify-center items-center'}>
              <h3>No transactions recorded</h3>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
